module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_6000.6bf2774f.png";